import "../../../utils/dataSetDefault";

import pipeline from "../../../utils/dataTables-scrollerCache";

/* Makes the autocomplete_candidates loaded in by the json_script filter available to our JS code. See:
https://docs.djangoproject.com/en/4.1/ref/templates/builtins/#json-script
*/
const nameAutocompleteWords = JSON.parse(
    document.getElementById("name-autocomplete-words").textContent
);
const codeAutocompleteWords = JSON.parse(
    document.getElementById("code-autocomplete-words").textContent
);
const formDefaults = JSON.parse(document.getElementById("form-defaults").textContent);
const maxResults = 10;
const formDataElement = document.getElementById("form-data");
const formData = formDataElement
    ? new Map(Object.entries(JSON.parse(formDataElement.textContent)))
    : undefined;

let recordsFilteredCache = undefined;
let recordsTotalCache = undefined;

/* setup for multi-word autocomplete, see: https://jqueryui.com/autocomplete/#multiple */
function split(val) {
    return val.split(/\s+/);
}

function extractLast(term) {
    return split(term).pop();
}

// puts beginning-of-string matches first, and limits to `maxResults` results
function myFilter(array, term) {
    let getMatches = function (matcher) {
        return $.grep(array, function (value) {
            return matcher.test(value.label || value.value || value);
        });
    };
    let escapedTerm = $.ui.autocomplete.escapeRegex(term);
    return getMatches(new RegExp("^" + escapedTerm, "i"))
        .concat(getMatches(new RegExp(".+" + escapedTerm, "i")))
        .slice(0, maxResults);
}

function setupAutocompleteField(field, words) {
    field
        .on("keydown", function (event) {
            if (
                event.keyCode === $.ui.keyCode.TAB &&
                $(this).autocomplete("instance").menu.active
            ) {
                event.preventDefault();
            }
        })
        .on("focus", function () {
            // open the autocomplete menu when the field is focused
            $(this).autocomplete("instance").search();
        })
        .autocomplete({
            minLength: 2,
            source: function (request, response) {
                // use our custom filter, extract the last word for completion:
                response(myFilter(words, extractLast(request.term)));
            },
            focus: function () {
                return false; // prevent value inserted on focus
            },
            select: function (event, ui) {
                let terms = split(this.value);
                terms.pop(); // remove the current input
                terms.push(ui.item.value); // add the selected item
                terms.push(""); // add placeholder to get the comma-and-space at the end
                this.value = terms.join(" ");
                return false;
            },
            search: function (event) {
                // customize "search" to get minLength working with multiple words
                let instance = $(this).autocomplete("instance");
                let lastWord = split(instance.term).pop(); // extract the last word
                if (lastWord.length < instance.options.minLength) {
                    instance.close(event);
                    return false;
                }
            },
        });
}

function resetFieldsetEnabling() {
    $("fieldset.term-code-fieldset").each(function () {
        let $inputs = $(this).find("input");
        let $filledInputs = $inputs.filter((_, elem) => {
            return $(elem).val();
        });
        if ($filledInputs.length > 1) {
            $filledInputs.val("");
        } else if ($filledInputs.length == 1) {
            $filledInputs.prop("disabled", false);
            $inputs.not($filledInputs).prop("disabled", true);
        } else {
            $inputs.prop("disabled", false);
        }
    });
}

function toggleSelectAll(selectAllElem, isInit = false) {
    let $choiceInputs = $(selectAllElem)
        .parent()
        .parent()
        .find(`input.form-check-input:not(#${selectAllElem.id})`);

    if (selectAllElem.checked) {
        // save current state of inputs, set to checked, and disable
        $choiceInputs
            .each(function () {
                $(this).data("savedInput", isInit ? true : this.checked);
                this.checked = true;
            })
            .attr("disabled", true);
    } else if (!isInit) {
        // return saved input state and re-enable checkboxes
        $choiceInputs
            .each(function () {
                this.checked = $(this).data("savedInput");
            })
            .attr("disabled", false);
    }
}

function wrapCellValue(col, value) {
    value = value == null ? "" : value;
    /* eslint-disable no-fallthrough */
    switch (col) {
        case 0:
            return `<a tabindex="0" role="button" class="replaceable-cell" data-bs-toggle="modal" data-bs-target="#replace-confirm-modal" data-target="#id_site_name">${value}</a>`;
        case 1:
            return `<a tabindex="0" role="button" class="replaceable-cell" data-bs-toggle="modal" data-bs-target="#replace-confirm-modal" data-target="#id_site_code">${value}</a>`;
        case 2:
            return `<a tabindex="0" role="button" class="replaceable-cell" data-bs-toggle="modal" data-bs-target="#replace-confirm-modal" data-target="#id_morphology_code">${value}</a>`;
        case 3:
        case 4:
            return `<a tabindex="0" role="button" class="replaceable-cell" data-bs-toggle="modal" data-bs-target="#replace-confirm-modal" data-target="#id_morphology_preferred_term">${value}</a>`;
        case 5:
            if (value === "Impossible") {
                return `<span class="impossible-status">${value}</span>`;
            }
        default:
            return `<span>${value}</span>`;
    }
    /* eslint-enable no-fallthrough */
}

function setReplaceFieldEvent() {
    $("#search-table-wrapper").one("click", ".replaceable-cell", function () {
        // query for elements
        let $this = $(this);
        let $target = $($this.data("target"));
        let label = $(`label[for="${$target.attr("id")}"]`).text();

        // fetch/process value
        let newVal = $this.text();
        newVal = $target.attr("name") == "morphology_code" ? newVal.split("/")[0] : newVal;

        // request confirmation, exit if canceled
        if (confirm(`Replace value in the ${label} field with "${newVal}"?`)) {
            // swap in value and reset fieldset enabling
            $target.parents("fieldset.term-code-fieldset").find("input").val("");
            $target.val(newVal);
            resetFieldsetEnabling();
        }

        setReplaceFieldEvent();
    });
}

function getRowHeight() {
    let width = window.innerWidth > 0 ? window.innerWidth : screen.width;

    if (width >= 1200) return 50;
    if (width >= 992) return 73;
    return 117;
}

$(function () {
    // set up autocomplete fields
    setupAutocompleteField($("#id_morphology_preferred_term"), nameAutocompleteWords);
    setupAutocompleteField($("#id_site_name"), codeAutocompleteWords);

    // fix tabs broken by general.js
    $('#search-tab-box [role="tabpanel"]').attr("aria-hidden", "");

    $(".tog-control button").attr("type", "button");

    // initialize tooltips
    $('[data-bs-toggle="tooltip"]').tooltip();

    // set up "Clear Search" button event
    $("#clear-search").on("click", function () {
        formDefaults.forEach((field) => {
            if (field.type === "CheckboxSelectMultiple") {
                $(`#${field.id} input[type="checkbox"]`).each((_, elem) => {
                    let $elem = $(elem);
                    if (field.default.some((e) => e == $elem.val())) {
                        $elem.prop("checked", true);
                    } else {
                        $elem.prop("checked", false);
                    }
                });
            } else {
                $(`#${field.id}`).val("");
            }
        });

        resetFieldsetEnabling();
    });

    // Disable/enable fieldset fields if other value has input
    $("fieldset.term-code-fieldset input").on("input", function () {
        resetFieldsetEnabling();
    });

    // Set initial enable/disable on fieldsets after search POST
    resetFieldsetEnabling();

    $("label:contains('Select All')")
        .siblings('input[type="checkbox"]')
        .each(function () {
            toggleSelectAll(this, true);
        })
        .on("change", function () {
            toggleSelectAll(this);
        });

    $("#code-list-table").DataTable({
        columnDefs: [
            { targets: 0, className: "dt-left", width: "min-content" },
            { targets: 1, className: "dt-left" },
        ],
        paging: false,
        searching: false,
        autoWidth: false,
    });

    let resultsTable = $("#results-table").DataTable({
        searching: false,
        // fixedHeader: true,
        order: [[2, "asc"]], // order by icd-o-3 morphology code by default
        columnDefs: [
            { targets: 0, width: "18%" },
            { targets: 1, width: "7%" },
            { targets: 2, width: "7%" },
            { targets: 3, width: "30%" },
            { targets: 4, width: "30%" },
            { targets: 5, width: "8%" },
        ],
        ajax: pipeline({
            // $.ajax settings
            url: "./update/",
            type: "POST",
            dataType: "json",
            headers: { "X-CSRFToken": $('#search-form input[name="csrfmiddlewaretoken"]').val() },
            // DataTables specific opts
            data: function (data) {
                data.form = Object.fromEntries(formData.entries());
                data.needTotalCount = recordsTotalCache === undefined;
                data.needFilteredCount = recordsFilteredCache === undefined;
            },
            dataSrc: function (data) {
                let returned = data.data;

                for (let i = 0; i < data.data.length; i++) {
                    for (let j = 0; j < data.data[i].length; j++) {
                        data.data[i][j] = wrapCellValue(j, data.data[i][j]);
                    }
                }

                // Pull cached total record count if exists
                if (recordsTotalCache !== undefined) {
                    data.recordsTotal = recordsTotalCache;
                } else {
                    recordsTotalCache = data.recordsTotal;
                }

                // Pull cached filtered record count if exists
                if (recordsFilteredCache !== undefined) {
                    data.recordsFiltered = recordsFilteredCache;
                } else {
                    recordsFilteredCache = data.recordsFiltered;
                }

                return returned;
            },
        }),
        dom: "<tS>",
        info: false,
        processing: true,
        lengthMenu: [-1],
        pageLength: 100,
        serverSide: true,
        deferRender: true,
        scroller: {
            rowHeight: getRowHeight(),
        },
        scrollY: 800,
        scrollX: true,
        scrollCollapse: true,
        autoWidth: false,
    });

    $(window).on("resize", () => {
        resultsTable.context[0].oScroller.s.heights.row = getRowHeight();
        resultsTable.draw();
    });

    /**
     * Set up field replacer modal confirmation
     */

    $("#replace-confirm-modal").on("show.bs.modal", function (event) {
        let $triggerElem = $(event.relatedTarget);
        let $targetElem = $($triggerElem.data("target"));
        let label = $(`label[for="${$targetElem.attr("id")}"]`).text();

        let newVal = $triggerElem.text();
        newVal = $targetElem.attr("name") == "morphology_code" ? newVal.split("/")[0] : newVal;

        $("#replace-confirm-modal span.replace-confirm-label").text(label);
        $("#replace-confirm-modal span.replace-confirm-value").text(newVal);
        $("#replace-confirm-modal button.confirm").data({
            target: $triggerElem.data("target"),
            newVal: newVal,
        });
    });

    $("#replace-confirm-modal button.confirm").on("click", function () {
        let $target = $($(this).data("target"));
        let newVal = $(this).data("newVal");

        // swap in value and reset fieldset enabling
        $target.parents("fieldset.term-code-fieldset").find("input").val("");
        $target.val(newVal);
        resetFieldsetEnabling();
    });
});
